export default __webpack_public_path__ + "static/media/SMK1.d67686c7.png";